import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.scss']
})
export class LoadingModalComponent{

  @Input() message: string = 'Cargando...'; // texto por defecto
  @Input() visible: boolean = false; // controla si el modal se muestra o 

}
